export const openJourneyPickerDates = () => {
  if (typeof window === 'undefined') return;
  const triggers = document.querySelectorAll<HTMLButtonElement>('[data-journey-picker-edit-dates]');
  const visible = Array.from(triggers).find((el) => el.offsetParent !== null);
  if (!visible) return;
  visible.scrollIntoView({ behavior: 'smooth', block: 'start' });
  if (visible.getAttribute('aria-expanded') !== 'true') {
    visible.click();
  }
};
